import script from "./MainRequestDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./MainRequestDetailView.vue?vue&type=script&setup=true&lang=js"

import "./MainRequestDetailView.vue?vue&type=style&index=0&id=dc5a7682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc5a7682"]])

export default __exports__